<app-generic-field [label]="'Flag: '">
  <w-single-dropdown [options]="options" [initialOption]="initialOption" [placeholder]="'Select a Flag'" (onValueChanges)="onValueChange($event)" [type]="'flags'"></w-single-dropdown>
</app-generic-field>
